import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import templateServices from '../../services/TemplateServices';


const BodyCenterComponent = (props) => {
  const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
  const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
  const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
  const container = 'bodyContainer';
  const position = 'mainContainer';
  const [compsList, setCompsList] = useState([]);

  useEffect(() => {
    const dataComps = templateServices.listDataCompsByContainerPosition(templateData, currentViewContainer, currentPageContainer, container, position);
    setCompsList(templateServices.listComponentsByDataNoGrid(dataComps, props.router) || (<div/>))
  }, [currentPageContainer])
  
  return (
    <div id="BodyCenterContainer" className={props.className}>
      {compsList}
    </div>
  );
}


export default React.memo(BodyCenterComponent);


// WEBPACK FOOTER //
// ./src/app/components/BodyCenterComponent/index.js